import axios from "axios";
import { baseurl } from "../Baseurl";

const axiosInstance = axios.create({
    baseURL: baseurl,
});

// Request interceptor to add the token
axiosInstance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("token");
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor to handle 401 errors
axiosInstance.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response && error.response.status === 401) {
            console.error("Unauthorized access - 401");
            // You can uncomment the following lines to auto-logout on invalid token
            // localStorage.clear();
            // window.location.href = "/";
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;
